import { Injectable } from '@angular/core';
import { Servers } from 'src/app/common/enumerations/servers-enum';

/**
 * Resolves which deployment the app is running on from the runtime host — the front-end
 * counterpart to the backend's `Util.IsProductionEnvironment()`.
 *
 * This keys off `document.location.hostname` / `Servers`, the same signal the app already uses
 * (menu-config-head, app.component, the auth services). It deliberately does NOT use the
 * build-time `environment.production` / `environment.config.production` flag: that flag is set
 * by hand in `assets/config.ts` and is not flipped by the production build (there is no
 * `fileReplacements` in angular.json), so it stays `false` in production and cannot be trusted
 * for gating tester-only tooling.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentService {

  /** True only when running on the production host (`ascc.als.lbl.gov`). */
  isProduction(): boolean {
    return document.location.hostname === Servers.PRODUCTION;
  }
}
